export class LoginErrorResponseModel {
	errorCode?: string;
	message?: string;
	errorFailedAttempts?: number;
	errorDuration?: number;
	mobileApkLink?: string;
	userData?:
		| string
		| {
				activationToken: string;
		  };

	constructor(errorModel: LoginErrorResponseModel) {
		this.errorCode = errorModel.errorCode;
		this.message = errorModel.message;
		this.errorFailedAttempts = errorModel.errorFailedAttempts;
		this.errorDuration = errorModel.errorDuration;
		this.userData = errorModel.userData;
		this.mobileApkLink = errorModel.mobileApkLink;
	}
}
